import { render } from "./AssignRole.vue?vue&type=template&id=0c74a927&ts=true"
import script from "./AssignRole.vue?vue&type=script&lang=ts"
export * from "./AssignRole.vue?vue&type=script&lang=ts"

import exportComponent from "/home/appstore/appstore/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__